module.exports = __webpack_public_path__ + "static/media/failuremark.e637bacd.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/failuremark.svg
// module id = 127
// module chunks = 0